<template>
  <div id="app" class="bg-gray-300">
    <Graph />
    <Nav />
    <SubjectCard />
    <FocusButton />
  </div>
</template>

<script>
import FocusButton from "./components/FocusButton.vue";
import SubjectCard from "./components/SubjectCard.vue";
import Graph from "./components/Graph.vue";
import Nav from "./components/Nav.vue";

export default {
  name: "App",
  components: {
    FocusButton,
    SubjectCard,
    Graph,
    Nav
  }
};
</script>

<style>
#app {
  @apply h-full w-full;
  overflow: hidden;
}

@screen md {
  /* @apply flex ; */
}
</style>
